/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.modalArrow[_ngcontent-%COMP%] { font-size : 30px; border : none; background : none }\n.modalArrow[_ngcontent-%COMP%]:hover { color : black; }\n.view[_ngcontent-%COMP%]   .tools[_ngcontent-%COMP%] { margin: 100px 0 0 0;}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvZ2l0bGFiLXJ1bm5lci9idWlsZHMvZDkwYzViY2YvMC9nYWlhL2dhaWEtdWktYW5ndWxhci9zcmMvYXBwL3Bvc3Rlci9saXN0L3Bvc3Rlci1saXN0LmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9naXRsYWItcnVubmVyL2J1aWxkcy9kOTBjNWJjZi8wL2dhaWEvZ2FpYS11aS1hbmd1bGFyL3NyYy9hcHAvcG9zdGVyL2xpc3QvcG9zdGVyLWxpc3QuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/$$_gendir/app/poster/list/poster-list.component.css.shim.ngstyle.ts